// Sample payloads for each template — used by the admin preview page
// and by manual `ga-send-email` test invocations.

const SITE = 'https://goaround.io';
const BOOKING_ID = '2841aabb-ccdd-eeff-1122-334455667788';
const TOKEN = 'demo-token-not-real-1234567890abcd';

const bookingCore = {
  bookingId: BOOKING_ID,
  vendorName: 'Snafu Bar',
  vendorAddress: '127 E 47th St, Midtown',
  date: '2026-05-21',
  startTime: '17:00:00',
  endTime: '19:00:00',
  offerTitle: '2 cocktails + bar bites',
  pricePerHeadCents: 4200,
  totalCents: 126000,
  headcount: 30,
  capacityMin: 4,
  capacityMax: 30,
  heroImage: 'https://qhmllsofvfyfieftczsc.supabase.co/storage/v1/object/public/vendor-photos/snafu-hero.jpg',
  organizerFirstName: 'Maya',
  organizerOrgName: 'Acme Robotics',
  siteUrl: SITE,
};

const rsvpUrls = {
  yesUrl: `${SITE}/invite/${TOKEN}?respond=yes`,
  maybeUrl: `${SITE}/invite/${TOKEN}?respond=maybe`,
  noUrl: `${SITE}/invite/${TOKEN}?respond=no`,
};

export const SAMPLE_DATA: Record<string, unknown> = {
  booking_confirmation: {
    ...bookingCore,
    manageUrl: `${SITE}/bookings/${BOOKING_ID}`,
    calendarUrl: `${SITE}/bookings/${BOOKING_ID}/calendar.ics`,
  },
  auto_cancellation: {
    ...bookingCore,
    rsvpYes: 3,
    rsvpMaybe: 2,
    rsvpNone: 12,
    refundCents: 126000,
    cardLast4: '4421',
    rescheduleUrl: `${SITE}/checkout/${BOOKING_ID}?reschedule=1`,
    browseUrl: `${SITE}/bars`,
    callout: '<strong>Try again with a Friday?</strong> Snafu Bar has a Friday 5 PM slot open this week, and Lupa &amp; Sons (NoMad) is wide open Thursday.',
  },
  post_event_recap: {
    ...bookingCore,
    arrived: 14,
    invited: 17,
    chargedCents: 117600,
    reviewUrl: `${SITE}/bars/snafu/review?booking=${BOOKING_ID}`,
    bookAgainUrl: `${SITE}/bars/snafu`,
  },
  invite: {
    ...bookingCore,
    ...rsvpUrls,
    yesCount: 17,
    invitedCount: 30,
    notOnTeamUrl: `${SITE}/invite/${TOKEN}/not-me`,
  },
  rsvp_confirmation: {
    ...bookingCore,
    inviteeFirstName: 'Jordan',
    calendarUrl: `${SITE}/bookings/${BOOKING_ID}/calendar.ics?token=${TOKEN}`,
    changeRsvpUrl: `${SITE}/invite/${TOKEN}`,
  },
  event_cancelled_invitee: {
    ...bookingCore,
    cancelledAt: '9:04 AM',
  },
  day_of_reminder: {
    ...bookingCore,
    inviteeFirstName: 'Jordan',
    yesCount: 17,
    maybeCount: 4,
    directionsUrl: `https://maps.google.com/?q=${encodeURIComponent(bookingCore.vendorAddress)}`,
    changeRsvpUrl: `${SITE}/invite/${TOKEN}`,
    attendeeInitials: ['M', 'P', 'D', 'A', 'J'],
  },
  rsvp_nudge_24h: {
    ...bookingCore,
    ...rsvpUrls,
    yesCount: 14,
    invitedCount: 30,
    floor: 18,
  },
  rsvp_nudge_12pm: {
    ...bookingCore,
    ...rsvpUrls,
  },
  vendor_booking_notification: {
    ...bookingCore,
    headcount: 17,
    organizerEmail: 'maya@acmerobotics.com',
    organizerFullName: 'Maya Chen',
    dietary: '1 gluten-free, 2 no-shellfish',
    doorName: 'Acme Robotics',
    dashboardUrl: `${SITE}/dashboard`,
    replyUrl: 'mailto:maya@acmerobotics.com',
  },
  vendor_headcount_lock: {
    ...bookingCore,
    headcount: 19,
    headcountDelta: 2,
    payoutCents: 79800,
    payoutDay: 'Fri',
    doorName: 'Acme',
    dietary: '1 GF, 2 no-shellfish, 1 sober-curious (NA options requested)',
    runSheetUrl: `${SITE}/dashboard/bookings/${BOOKING_ID}/run-sheet`,
  },
  vendor_booking_cancelled: {
    ...bookingCore,
    reason: 'Auto-cancel · below 4-person floor',
    openSlotsUrl: `${SITE}/dashboard/availability`,
  },
  vendor_weekly_summary: {
    vendorName: 'Snafu Bar',
    weekBookings: 4,
    weekBookingsDelta: 1,
    weekRevenueCents: 512400,
    weekChangePct: 22,
    avgRating: 4.8,
    ratingDelta: 0.2,
    upcoming: [
      { date: 'Tue 5/27', teamName: 'Linear', headcount: 22, packageTitle: 'Cocktails + bites', revenueCents: 92400 },
      { date: 'Thu 5/29', teamName: 'Acme Robotics', headcount: 18, packageTitle: 'Open bar', revenueCents: 126000 },
    ],
    dashboardUrl: `${SITE}/dashboard`,
    updateOfferUrl: `${SITE}/dashboard/offers`,
    settingsUrl: `${SITE}/dashboard/settings`,
    siteUrl: SITE,
  },
  magic_link: {
    signInUrl: `${SITE}/auth/callback?token=eyJhbGc...`,
    code: '472 819',
    ttlMinutes: 10,
    siteUrl: SITE,
  },
  welcome: {
    firstName: 'Maya',
    planUrl: `${SITE}/bars`,
    faqUrl: `${SITE}/how-it-works`,
    siteUrl: SITE,
  },
  vendor_team_invite: {
    inviteeFirstName: 'Jordan',
    inviterFullName: 'Anna Petrov',
    inviterEmail: 'anna@snafubar.nyc',
    vendorName: 'Snafu Bar',
    vendorNeighborhood: 'Midtown',
    role: 'Manager',
    acceptUrl: `${SITE}/dashboard/invite/accept?token=${TOKEN}`,
    declineUrl: `${SITE}/dashboard/invite/decline?token=${TOKEN}`,
    siteUrl: SITE,
  },
  vendor_welcome: {
    firstName: 'Anna',
    vendorName: 'Snafu Bar',
    continueUrl: `${SITE}/onboarding`,
    faqUrl: `${SITE}/for-restaurants`,
    siteUrl: SITE,
  },
};
